<template lang="html">
  <div>
    <template v-if="tags.length > 0">
      <v-chip
        small
        class="mr-2"
        v-for="(tag, i) in tags"
        :key="`tag-${i}`"
        close
        @click:close="removeTag(tag)"
      >
        {{ tag.name }}
      </v-chip>
    </template>
    <v-chip @click="dialog = true" small color="success">
      <v-icon small class="mr-2">
        mdi-plus-circle
      </v-icon>
      {{ capitalize($t('general.add')) }}
    </v-chip>
    <BaseDialog
      v-model="dialog"
      :title="$tc('resources.tag', 1)"
      @cancel="dialog = false"
      @continue="addTag"
    >
      <template #content>
        <Textfield
          v-model="newTag"
          :placeholder="$tc('resources.tag', 1)"
        />
      </template>
    </BaseDialog>
  </div>
</template>

<script>
import { capitalize, findIndex } from 'lodash';
import localValue from '@/mixins/localValue';

export default {
  mixins: [localValue],
  name: 'TagsInput',
  data() {
    return {
      dialog: false,
      newTag: '',
    };
  },
  computed: {
    tags() {
      return this.localValue?.filter(x => !x._destroy) || [];
    },
  },
  methods: {
    capitalize,
    removeTag(tag) {
      const index = findIndex(this.localValue, x => x === tag);
      if (index < 0) return;
      this.$set(this.localValue[index], '_destroy', true);
    },
    addTag() {
      this.dialog = false;
      this.localValue.push({ name: this.newTag });
      this.newTag = '';
    },
  },
};
</script>
